'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/10/8.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = require('react-collapse');

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import FlipCard from '../FlipCard/FlipCard';

var ListPageFilterBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ListPageFilterBar, _Component);

  function ListPageFilterBar() {
    (0, _classCallCheck3.default)(this, ListPageFilterBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ListPageFilterBar).call(this));

    _this.state = {
      selectedFirstItemId: '',
      selectedSecondItemId: '',
      secondLevelLoad: false,
      secondItemMoreBtnClick: '',
      fourthItemBottomItemsFlipInfo: {},
      thirdHeaderId: '1'
    };
    return _this;
  }

  (0, _createClass3.default)(ListPageFilterBar, [{
    key: 'onFirstItemClick',
    value: function onFirstItemClick(item) {
      var _props = this.props;
      var firstItemClick = _props.firstItemClick;
      var firstConstItemClick = _props.firstConstItemClick;
      var onChangeSelectedFirstItemId = _props.onChangeSelectedFirstItemId;

      var secondLevelLoad = false;
      if (item.loadData === '1' && firstItemClick) {
        firstItemClick(item.id);
        secondLevelLoad = true;
      } else if (firstConstItemClick) {
        firstConstItemClick(item.id);
      }
      if (onChangeSelectedFirstItemId) {
        onChangeSelectedFirstItemId(item.id);
      }
      this.setState({
        // selectedFirstItemId: item.id,
        secondLevelLoad: secondLevelLoad,
        secondNotShowThird: item.loadData
      });
    }
  }, {
    key: 'onSecondItemMoreBtnClick',
    value: function onSecondItemMoreBtnClick() {
      var secondItemMoreBtnClick = this.state.secondItemMoreBtnClick;

      var currentState = '1';
      if (secondItemMoreBtnClick) {
        currentState = '';
      }
      this.setState({
        secondItemMoreBtnClick: currentState
      });
    }
  }, {
    key: 'onSecondItemBackBtnClick',
    value: function onSecondItemBackBtnClick() {
      var _props2 = this.props;
      var secondItemClick = _props2.secondItemClick;
      var onChangeSelectedFirstItemId = _props2.onChangeSelectedFirstItemId;

      if (secondItemClick) {
        secondItemClick();
      }
      onChangeSelectedFirstItemId('2');
      this.setState({
        // selectedFirstItemId: '2',
        secondItemMoreBtnClick: ''
      });
    }
  }, {
    key: 'onSecondItemClick',
    value: function onSecondItemClick(currentItem) {
      // const {selectedFirstItemId } = this.state;
      var _props3 = this.props;
      var secondItemClick = _props3.secondItemClick;
      var changeShownOfBelow = _props3.changeShownOfBelow;
      var selectedFirstItemId = _props3.selectedFirstItemId;
      var onChangeSelectedSecondItemId = _props3.onChangeSelectedSecondItemId;

      if (secondItemClick && onChangeSelectedSecondItemId) {
        secondItemClick(selectedFirstItemId, currentItem.id);
        onChangeSelectedSecondItemId(currentItem.id);
        this.setState({
          // selectedSecondItemId: currentItem.id,
          selectedSecondItem: currentItem
        });
      }
      if (changeShownOfBelow) {
        changeShownOfBelow(false);
      }
    }
  }, {
    key: 'onThirdHeaderClick',
    value: function onThirdHeaderClick(id) {
      this.setState({
        thirdHeaderId: id
      });
    }
  }, {
    key: 'onFourthItemMouseOver',
    value: function onFourthItemMouseOver(id) {
      var fourthItemBottomItemsFlipInfo = this.state.fourthItemBottomItemsFlipInfo;

      var info = (0, _extends3.default)({}, fourthItemBottomItemsFlipInfo);
      info[id] = true;
      this.setState({
        fourthItemBottomItemsFlipInfo: info
      });
    }
  }, {
    key: 'onFourthItemMouseLeave',
    value: function onFourthItemMouseLeave(id) {
      var fourthItemBottomItemsFlipInfo = this.state.fourthItemBottomItemsFlipInfo;

      var info = (0, _extends3.default)({}, fourthItemBottomItemsFlipInfo);
      info[id] = false;
      this.setState({
        fourthItemBottomItemsFlipInfo: info
      });
    }
  }, {
    key: 'fourthBackBtnClick',
    value: function fourthBackBtnClick(type) {
      var _props4 = this.props;
      var changeShownOfBelow = _props4.changeShownOfBelow;
      var onChangeSelectedSecondItemId = _props4.onChangeSelectedSecondItemId;
      var selectedFirstItemId = _props4.selectedFirstItemId;
      var onFourthConstBackBtnClick = _props4.onFourthConstBackBtnClick;

      if (changeShownOfBelow) {
        changeShownOfBelow(true);
      }
      if (onChangeSelectedSecondItemId) {
        onChangeSelectedSecondItemId('');
      }

      if (type === 'FourthOther' && selectedFirstItemId) {
        onFourthConstBackBtnClick(selectedFirstItemId);
      }

      this.setState({
        // selectedSecondItemId: '',
        selectedSecondItem: null
      });
    }
  }, {
    key: 'analysisSecondLoadDiv',
    value: function analysisSecondLoadDiv(isOpened, secondSectionClassName) {
      var _this2 = this;

      var _props5 = this.props;
      var data = _props5.data;
      var selectedFirstItemId = _props5.selectedFirstItemId;
      var thirdHeaderId = this.state.thirdHeaderId;

      var styles = require('./ListPageFilterBar.scss');
      var secondImgs = [];
      var thirdHeaderArray = [{ id: '1', name: 'ABCDEFG' }, { id: '2', name: 'HIJKLM' }, { id: '3', name: 'NOPQRS' }, { id: '4', name: 'TUVWXYZ' }];
      // let isShopOrDesigner = true;
      var thirdItemArray = [];
      /* if (data instanceof Array) {
       data.forEach((currentItem, index)=> {
       if (currentItem.recommand === '1' && secondImgs.length < 8) {
       let currentClassName = styles.loadItemLi;
       if (secondImgs.length % 4 === 3) {
       currentClassName += ' ' + styles.loadPaddingRight;
       }
       if (secondImgs.length > 3) {
       currentClassName += ' ' + styles.loadMarginTop;
       }
       secondImgs.push(<li key={index} onClick={()=>this.onSecondItemClick(currentItem)}
       className={currentClassName}><img
       src={currentItem.img} alt=""/>
       {
       selectedFirstItemId === 'M004313' ? (<div className={styles.nameContainer}>
       <div className={styles.nameDiv} style={{height: 75}}></div>
       <h3 className={styles.honorText}>{currentItem.honor}</h3>
       <h3 className={styles.nameText}>{currentItem.name}</h3>
       <h3 className={styles.fieldText}>{currentItem.field}</h3>
       </div>) : (<div className={styles.nameContainer}>
       <div className={styles.nameDiv}></div>
       <h3 className={styles.nameText} style={{width: '209px'}}>{currentItem.name}</h3>
       </div>)
       }
       </li>);
       }
       const currentThirdHeader = thirdHeaderArray.find((item)=>item.id === thirdHeaderId);
       if (currentThirdHeader && currentItem.groupId.length > 0 && currentThirdHeader.name.split('').indexOf(currentItem.groupId[0]) > -1) {
       thirdItemArray.push(<li key={index} onClick={()=>this.onSecondItemClick(currentItem)}
       className={styles.thirdItemText}> {currentItem.name}</li>);
       }
       });
       }
       */
      if (data instanceof Array) {
        data.forEach(function (currentItem, index) {
          if (currentItem.recommand === '1' && secondImgs.length < 4) {
            var currentClassName = styles.loadItemLi;
            if (secondImgs.length % 4 === 3) {
              currentClassName += ' ' + styles.loadMarginRight;
            }
            secondImgs.push(_react2.default.createElement(
              'li',
              { key: 'secondLoadImgs' + index, onClick: function onClick() {
                  return _this2.onSecondItemClick(currentItem);
                },
                className: currentClassName },
              _react2.default.createElement('img', { src: currentItem.img, alt: '' }),
              selectedFirstItemId === 'M004313' ? _react2.default.createElement(
                'div',
                { className: styles.nameContainer },
                _react2.default.createElement('div', { className: styles.nameDiv, style: { height: 75 } }),
                _react2.default.createElement(
                  'h3',
                  { className: styles.honorText },
                  currentItem.honor
                ),
                _react2.default.createElement(
                  'h3',
                  { className: styles.nameText },
                  currentItem.name
                ),
                _react2.default.createElement(
                  'h3',
                  { className: styles.fieldText },
                  currentItem.field
                )
              ) : _react2.default.createElement(
                'div',
                { className: styles.nameContainer },
                _react2.default.createElement('div', { className: styles.nameDiv }),
                _react2.default.createElement(
                  'h3',
                  { className: styles.nameText, style: { width: '100%' } },
                  currentItem.name
                )
              )
            ));
          }
          var currentThirdHeader = thirdHeaderArray.find(function (item) {
            return item.id === thirdHeaderId;
          });
          if (currentThirdHeader && currentItem.groupId.length > 0 && currentThirdHeader.name.split('').indexOf(currentItem.groupId[0]) > -1) {
            thirdItemArray.push(_react2.default.createElement(
              'li',
              { key: 'secondLoadThirdItem' + index, onClick: function onClick() {
                  return _this2.onSecondItemClick(currentItem);
                },
                className: styles.thirdItemText },
              ' ',
              currentItem.name
            ));
          }
        });
      }
      return _react2.default.createElement(
        'section',
        { className: secondSectionClassName },
        _react2.default.createElement(
          'span',
          { onClick: this.onSecondItemBackBtnClick.bind(this), className: styles.leftBig },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/all_fenlei.jpg', alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.rightBig },
          _react2.default.createElement(
            'ul',
            null,
            secondImgs
          )
        ),
        _react2.default.createElement(
          'span',
          { onClick: this.onSecondItemMoreBtnClick.bind(this), className: styles.addBtn },
          _react2.default.createElement('img', {
            src: isOpened ? 'http://tupian.goeasy.cn:9999/yipinwang/third/shuaixuan_app.png' : 'http://tupian.goeasy.cn:9999/yipinwang/third/shuaixuan_add.png',
            alt: '' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          _reactCollapse2.default,
          { isOpened: isOpened },
          _react2.default.createElement(
            'div',
            { className: styles.thirdItem },
            _react2.default.createElement(
              'div',
              { className: styles.thirdHeader },
              _react2.default.createElement(
                'div',
                { className: styles.shaixuan_tishi },
                '按拼音首字母'
              ),
              thirdHeaderArray instanceof Array ? thirdHeaderArray.map(function (currentItem, index) {
                var currentItemClass = styles.shaixuan_zimu;
                if (currentItem.id === thirdHeaderId) {
                  currentItemClass = styles.shaixuan_zimu + ' ' + styles.active;
                }
                return _react2.default.createElement(
                  'div',
                  { onClick: function onClick() {
                      return _this2.onThirdHeaderClick(currentItem.id);
                    }, key: 'thirdHeaderArray' + index,
                    className: currentItemClass },
                  currentItem.name
                );
              }) : ''
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { style: { width: '100%', height: 37 } },
              _react2.default.createElement(
                'ul',
                null,
                thirdItemArray
              )
            )
          )
        )
      );
    }
  }, {
    key: 'analysisSecondConstDiv',
    value: function analysisSecondConstDiv(isOpened, secondSectionClassName) {
      var _this3 = this;

      var secondLevel = this.props.secondLevel;

      var styles = require('./ListPageFilterBar.scss');
      var secondImgs = [];
      var thirdItemArray = [];
      secondLevel.forEach(function (currentItem, index) {
        if (secondImgs.length < 6) {
          /*
           let currentClassName = styles.img;
           let imgClass = styles.eImg;
           switch (secondImgs.length) {
           case 1:
           currentClassName = styles.img + ' ' + styles.imgMarginLeft;
           imgClass = styles.smallImg;
           break;
           case 2:
           currentClassName = styles.img + ' ' + styles.imgMarginLeft;
           imgClass = styles.bigImg;
           break;
           case 3:
           currentClassName = styles.img + ' ' + styles.imgMarginTop;
           imgClass = styles.bigImgTwo;
           break;
           case 4:
           currentClassName = styles.img + ' ' + styles.imgMarginLeft + ' ' + styles.imgMarginTop;
           imgClass = styles.smallImgThree;
           break;
           case 5:
           currentClassName = styles.img + ' ' + styles.imgMarginLeft + ' ' + styles.imgMarginTop;
           imgClass = styles.smallImgFour;
           break;
           default :
           break;
           }
           secondImgs.push(<span key={index} onClick={()=>this.onSecondItemClick(currentItem)}
           className={currentClassName}><img className={imgClass}
           src={currentItem.img} alt=""/></span>);
           */
          var currentClassName = styles.img + ' ' + styles.imgSize;
          switch (secondImgs.length) {
            case 1:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginLeft;
              break;
            case 2:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginLeft;
              break;
            case 3:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginTop;
              break;
            case 4:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginLeft + ' ' + styles.imgMarginTop;
              break;
            case 5:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginLeft + ' ' + styles.imgMarginTop;
              break;
            default:
              break;
          }
          secondImgs.push(_react2.default.createElement(
            'span',
            { key: 'secondImgs' + index, onClick: function onClick() {
                return _this3.onSecondItemClick(currentItem);
              },
              className: currentClassName },
            _react2.default.createElement('img', { src: currentItem.img, alt: '' })
          ));
        } else {
          thirdItemArray.push(_react2.default.createElement(
            'li',
            { key: 'thirdItemArray' + index, onClick: function onClick() {
                return _this3.onSecondItemClick(currentItem);
              },
              className: styles.thirdItemLi, style: { paddingRight: index === 9 ? 0 : 7 } },
            _react2.default.createElement('img', {
              src: currentItem.img })
          ));
        }
      });
      return _react2.default.createElement(
        'section',
        { className: secondSectionClassName },
        _react2.default.createElement(
          'span',
          { onClick: this.onSecondItemBackBtnClick.bind(this), className: styles.leftBig },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/all_fenlei.jpg', alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.rightBig },
          secondImgs,
          _react2.default.createElement('div', { className: 'clear' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          _reactCollapse2.default,
          { isOpened: isOpened },
          _react2.default.createElement(
            'div',
            { className: styles.thirdItem, style: { height: 128 } },
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { style: { width: '100%', height: 37 } },
              _react2.default.createElement(
                'ul',
                null,
                thirdItemArray
              )
            )
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'span',
          { onClick: this.onSecondItemMoreBtnClick.bind(this), className: styles.addBtn },
          _react2.default.createElement('img', {
            src: isOpened ? 'http://tupian.goeasy.cn:9999/yipinwang/third/shuaixuan_app.png' : 'http://tupian.goeasy.cn:9999/yipinwang/third/shuaixuan_add.png',
            alt: '' })
        )
      );
    }
  }, {
    key: 'analysisSecondConstDiv2',
    value: function analysisSecondConstDiv2(isOpened, secondSectionClassName) {
      var _this4 = this;

      var secondLevel = this.props.secondLevel;

      var styles = require('./ListPageFilterBar.scss');
      var topMidFourDiv = [];
      var bottomMidFourDiv = [];
      var topRight = '';
      var bottomLeft = '';
      var bottomRight = '';
      secondLevel.forEach(function (currentItem, index) {
        var currentClassName = '';
        switch (index % 6) {
          case 1:
            currentClassName = styles.ml7;
            break;
          case 2:
            currentClassName = styles.mt6;
            break;
          case 3:
            currentClassName = styles.mt6 + ' ' + styles.ml7;
            break;
          default:
            break;
        }
        switch (index) {
          case 0:
          case 1:
          case 2:
          case 3:
            topMidFourDiv.push(_react2.default.createElement(
              'a',
              { key: 'topMidFourDiv' + index, onClick: function onClick() {
                  return _this4.onSecondItemClick(currentItem);
                },
                className: currentClassName },
              _react2.default.createElement('img', {
                src: currentItem.img,
                alt: '' })
            ));
            break;
          case 4:
            topRight = _react2.default.createElement(
              'a',
              { className: styles.shx_a, onClick: function onClick() {
                  return _this4.onSecondItemClick(currentItem);
                } },
              _react2.default.createElement('img', { src: currentItem.img,
                alt: '' })
            );
            break;
          case 5:
            bottomLeft = _react2.default.createElement(
              'a',
              { className: styles.shx_a, onClick: function onClick() {
                  return _this4.onSecondItemClick(currentItem);
                } },
              _react2.default.createElement('img', { src: currentItem.img,
                alt: '' })
            );
            break;
          case 6:
          case 7:
          case 8:
          case 9:
            bottomMidFourDiv.push(_react2.default.createElement(
              'a',
              { key: 'bottomMidFourDiv' + index, onClick: function onClick() {
                  return _this4.onSecondItemClick(currentItem);
                },
                className: currentClassName },
              _react2.default.createElement('img', {
                src: currentItem.img, alt: '' })
            ));
            break;
          case 10:
            bottomRight = _react2.default.createElement(
              'a',
              { className: styles.shx_a, onClick: function onClick() {
                  return _this4.onSecondItemClick(currentItem);
                } },
              _react2.default.createElement('img', { src: currentItem.img,
                alt: '' })
            );
            break;
          default:
            break;
        }
      });
      return _react2.default.createElement(
        'section',
        { className: secondSectionClassName },
        _react2.default.createElement(
          'a',
          { className: styles.shx_a, onClick: this.onSecondItemBackBtnClick.bind(this) },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/all_fenlei.jpg', alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.shx_b },
          topMidFourDiv
          /*  <a><img src="http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg7.jpg" alt=""/></a>
           <a className={styles.ml7}><img src="http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg8.jpg" alt=""/></a>
           <a className={styles.mt6}><img src="http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg10.jpg"
           alt=""/></a>
           <a className={styles.mt6 + ' ' + styles.ml7}><img
           src="http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg11.jpg" alt=""/></a>*/
        ),
        topRight
        /* <a className={styles.shx_a}><img src="http://tupian.goeasy.cn:9999/yipinwang/newthird/fenleibg9.jpg"
         alt=""/></a>*/,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          _reactCollapse2.default,
          { isOpened: isOpened },
          bottomLeft,
          _react2.default.createElement(
            'div',
            { className: styles.shx_b },
            bottomMidFourDiv
          ),
          bottomRight,
          _react2.default.createElement('div', { className: 'clear' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'span',
          { onClick: this.onSecondItemMoreBtnClick.bind(this), className: styles.addBtn },
          _react2.default.createElement('img', {
            src: isOpened ? 'http://tupian.goeasy.cn:9999/yipinwang/third/shuaixuan_app.png' : 'http://tupian.goeasy.cn:9999/yipinwang/third/shuaixuan_add.png',
            alt: '' })
        )
      );
    }
  }, {
    key: 'analysisSecondDiv',
    value: function analysisSecondDiv(isOpened, secondSectionClassName) {
      var secondLevelLoad = this.state.secondLevelLoad;

      var result = '';
      if (secondLevelLoad) {
        result = this.analysisSecondLoadDiv(isOpened, secondSectionClassName);
      } else {
        result = this.analysisSecondConstDiv2(isOpened, secondSectionClassName);
      }
      return result;
    }
  }, {
    key: 'analysisFourthShopAndDesignerDiv',
    value: function analysisFourthShopAndDesignerDiv(fourthSectionClassName, selectedFirstItemId) {
      var styles = require('./ListPageFilterBar.scss');
      // const {fourthItemBottomItemsFlipInfo, selectedSecondItem} = this.state;
      // let currentItem = 'shop';
      // if (selectedFirstItemId === 'M004313') {
      //   currentItem = 'designer';
      // }
      // let bigImgUrl = '';
      var bottomImgs = [];
      var fourthLevel = this.props.fourthLevel;
      var selectedSecondItem
      // , fourthItemBottomItemsFlipInfo
      = this.state.selectedSecondItem;

      fourthLevel.forEach(function (item) {
        if (item.parentId === selectedFirstItemId) {
          if (
          // bigImgUrl = item.topImg;
          item.bottomItems instanceof Array) {
            item.bottomItems.forEach(function (bottomItem, index) {
              bottomImgs.push(_react2.default.createElement(
                'li',
                { key: 'bottomImgs' + index },
                _react2.default.createElement(
                  'i',
                  { className: styles.front },
                  _react2.default.createElement('img', { src: bottomItem.front, alt: '' })
                )
              ));
            });
          }
        }
      });
      // http://tupian.goeasy.cn:9999/yipinwang/third/zhongsbg.png
      return _react2.default.createElement(
        'section',
        { className: fourthSectionClassName },
        _react2.default.createElement(
          'div',
          { className: styles.shopAndDesignerDivTop },
          _react2.default.createElement(
            'div',
            { className: styles.img_back },
            _react2.default.createElement('img', {
              src: selectedSecondItem && selectedSecondItem.backImg ? selectedSecondItem.backImg : 'http://tupian.goeasy.cn:9999/yipinwang/third/zhongsbg.png',
              alt: '' })
          )
        ),
        _react2.default.createElement(
          'span',
          { className: styles.shopAndDesignerBackBtn, onClick: this.fourthBackBtnClick.bind(this) },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_back.png', alt: '' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.shopAndDesignerDivBottom },
          _react2.default.createElement('div', { className: styles.link + ' ' + styles.marginL }),
          _react2.default.createElement(
            'div',
            { className: styles.middle },
            _react2.default.createElement(
              'ul',
              null,
              bottomImgs
            )
          ),
          _react2.default.createElement('div', { className: styles.link })
        )
      );
    }
  }, {
    key: 'analysisFourthOtherDiv',
    value: function analysisFourthOtherDiv(fourthSectionClassName) {
      var _this5 = this;

      var styles = require('./ListPageFilterBar.scss');
      var bigImgUrl = '';
      var bottomImgs = [];
      var _props6 = this.props;
      var fourthLevel = _props6.fourthLevel;
      var selectedSecondItemId = _props6.selectedSecondItemId;
      /* const {selectedSecondItemId
       // , fourthItemBottomItemsFlipInfo
       } = this.state;*/

      fourthLevel.forEach(function (item) {
        if (item.parentId === selectedSecondItemId) {
          bigImgUrl = item.topImg;
          if (item.bottomItems instanceof Array) {
            item.bottomItems.forEach(function (bottomItem, index) {
              bottomImgs.push(_react2.default.createElement(
                'li',
                { key: 'bottomImgs' + index },
                _react2.default.createElement(
                  'i',
                  { className: styles.front },
                  _react2.default.createElement('img', { src: bottomItem.front, alt: '' })
                )
              ));
            });
          }
        }
      });
      return _react2.default.createElement(
        'section',
        { className: fourthSectionClassName },
        _react2.default.createElement(
          'div',
          { className: styles.fourthItemTopImg },
          _react2.default.createElement('img', { src: bigImgUrl, alt: '' })
        ),
        _react2.default.createElement(
          'span',
          { className: styles.fourthItemBackImg, onClick: function onClick() {
              return _this5.fourthBackBtnClick('FourthOther');
            } },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_back.png', alt: '' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.fourthItemTopImg + ' ' + styles.fourthMarginTop },
          _react2.default.createElement('div', { className: styles.fourthItemLine + ' ' + styles.fourthMarginLeft }),
          _react2.default.createElement(
            'div',
            { className: styles.fourthItemBottom },
            _react2.default.createElement(
              'ul',
              null,
              bottomImgs
            )
          ),
          _react2.default.createElement('div', { className: styles.fourthItemLine })
        )
      );
    }
  }, {
    key: 'analysisFourthDiv',
    value: function analysisFourthDiv(fourthSectionClassName) {
      var selectedFirstItemId = this.props.selectedFirstItemId;

      var result = '';
      if (selectedFirstItemId === 'M004257' || selectedFirstItemId === 'M004313') {
        result = this.analysisFourthShopAndDesignerDiv(fourthSectionClassName, selectedFirstItemId);
      } else {
        result = this.analysisFourthOtherDiv(fourthSectionClassName);
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var styles = require('./ListPageFilterBar.scss');
      var _state = this.state;
      var secondItemMoreBtnClick = _state.secondItemMoreBtnClick;
      var secondLevelLoad = _state.secondLevelLoad;
      var _props7 = this.props;
      var firstLevel = _props7.firstLevel;
      var data = _props7.data;
      var selectedFirstItemId = _props7.selectedFirstItemId;
      var selectedSecondItemId = _props7.selectedSecondItemId;

      var firstSectionClassName = styles.itemActived + ' ' + styles.animated;
      var secondSectionClassName = styles.animated;
      var fourthSectionClassName = styles.animated;
      var isOpened = false;
      if (secondLevelLoad && data instanceof Array && data.length > 0 || !secondLevelLoad && selectedFirstItemId) {
        if (selectedFirstItemId === '2') {
          firstSectionClassName = styles.animated + ' ' + styles.itemActived + ' ' + styles.fadeInLeftBig;
        } else if (firstLevel.find(function (item) {
          return item.id === selectedFirstItemId;
        })) {
          firstSectionClassName = styles.animated + ' ' + styles.fadeOutLeftBig;
          secondSectionClassName = styles.animated + ' ' + styles.itemActived + ' ' + styles.fadeInRightBig;
          if (secondItemMoreBtnClick) {
            isOpened = true;
          }
        }
      }
      if (selectedSecondItemId) {
        fourthSectionClassName = styles.animated + ' ' + styles.itemActived + ' ' + styles.fadeInRightBig;
        secondSectionClassName = styles.animated;
      }
      var leftBigItem = _react2.default.createElement(
        'span',
        { onClick: function onClick() {
            return _this6.onFirstItemClick(firstLevel[0]);
          }, className: styles.leftBig },
        _react2.default.createElement('img', {
          src: firstLevel[0].img, alt: '' })
      );
      var rightBigItems = _react2.default.createElement(
        'div',
        { className: styles.rightBig },
        _react2.default.createElement(
          'div',
          { style: { float: 'left', width: 379, height: 255 } },
          _react2.default.createElement(
            'span',
            { onClick: function onClick() {
                return _this6.onFirstItemClick(firstLevel[1]);
              }, className: styles.img },
            _react2.default.createElement('img', { src: firstLevel[1].img, alt: '' })
          ),
          _react2.default.createElement(
            'span',
            { onClick: function onClick() {
                return _this6.onFirstItemClick(firstLevel[2]);
              }, className: styles.img, style: { marginTop: 4 } },
            _react2.default.createElement('img', { src: firstLevel[2].img, alt: '' })
          )
        ),
        _react2.default.createElement(
          'span',
          { onClick: function onClick() {
              return _this6.onFirstItemClick(firstLevel[3]);
            }, className: styles.img,
            style: { width: 250, height: 255, marginLeft: 7 } },
          _react2.default.createElement('img', { src: firstLevel[3].img, alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { style: { float: 'left', width: 379, height: 255, marginLeft: 7 } },
          _react2.default.createElement(
            'span',
            { onClick: function onClick() {
                return _this6.onFirstItemClick(firstLevel[4]);
              }, className: styles.img },
            _react2.default.createElement('img', { src: firstLevel[4].img, style: { width: 379 }, alt: '' })
          ),
          _react2.default.createElement(
            'span',
            { onClick: function onClick() {
                return _this6.onFirstItemClick(firstLevel[5]);
              }, className: styles.img, style: { marginTop: 4 } },
            _react2.default.createElement('img', { src: firstLevel[5].img, alt: '' })
          )
        )
      );
      /*
       const rightBigItems = [];
       firstLevel.forEach((item, index)=> {
       if (index === 0) {
       leftBigItem = (<span onClick={()=>this.onFirstItemClick(item)} className={styles.leftBig}><img
       src={item.img} alt=""/></span>);
       } else {
       let currentClassName = styles.img;
       switch (index) {
       case 2:
       currentClassName = styles.img + ' ' + styles.imgMarginLeft;
       break;
       case 3:
       currentClassName = styles.img + ' ' + styles.imgMarginTop;
       break;
       case 4:
       currentClassName = styles.img + ' ' + styles.imgMarginLeft + ' ' + styles.imgMarginTop;
       break;
       case 5:
       currentClassName = styles.img + ' ' + styles.imgMarginLeft + ' ' + styles.imgMarginTop;
       break;
       default :
       break;
       }
       rightBigItems.push(<span onClick={()=>this.onFirstItemClick(item)} key={index}
       className={currentClassName}><img
       src={item.img} alt=""/></span>);
       }
       }); */

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'section',
          { className: firstSectionClassName },
          leftBigItem,
          rightBigItems
        ),
        this.analysisSecondDiv(isOpened, secondSectionClassName),
        this.analysisFourthDiv(fourthSectionClassName)
      );
    }
  }]);
  return ListPageFilterBar;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array,
  firstLevel: _react.PropTypes.array,
  secondLevel: _react.PropTypes.array,
  fourthLevel: _react.PropTypes.array,
  selectedFirstItemId: _react.PropTypes.string,
  selectedSecondItemId: _react.PropTypes.string,
  onChangeSelectedFirstItemId: _react.PropTypes.func,
  onChangeSelectedSecondItemId: _react.PropTypes.func,
  firstItemClick: _react.PropTypes.func,
  changeShownOfBelow: _react.PropTypes.func,
  secondItemClick: _react.PropTypes.func,
  firstConstItemClick: _react.PropTypes.func,
  onFourthConstBackBtnClick: _react.PropTypes.func
}, _temp);
exports.default = ListPageFilterBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ListPageFilterBar/ListPageFilterBar.js
 ** module id = 1361
 ** module chunks = 0
 **/